import { Link } from "@fluentui/react-components";
import styled from "styled-components";

import { Flex } from "components/styled";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/GrECo_Logo_small.jpg";

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Container>
        <img
          className="logo"
          src={Logo}
          alt={"GrECo logo"}
          style={{
            height: "44px",
          }}
        />
        <MessageWrap>
          <MessageHeader>{t("qtg.notFound.title")}</MessageHeader>
          <MessageBody>{t("qtg.notFound.message")}</MessageBody>
        </MessageWrap>

        <Flex
          direction="column"
          gap={"5px"}
          $align="flex-start"
          style={{
            marginTop: "20px",
          }}
        >
          <Link
            id="returnHome"
            onClick={() => {
              navigate("/");
            }}
          >
            {t("qtg.notFound.returnHome")}
          </Link>
        </Flex>
      </Container>
    </>
  );
}

const Container = styled.div`
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

const MessageWrap = styled.div``;

const MessageHeader = styled.h1`
  margin: 40px 0 20px;
`;
const MessageBody = styled.div``;
